mutation DeleteInvestmentPool($id: ID!) {
  deleteInvestmentPool(input: { id: $id }) {
    success
  }
}
